export enum MessageLevel {
    ERROR,
    WARNING,
    SUCCESS,
    INFO
}

export enum MessageLayout {
    HORIZONTAL,
    VERTICAL,
}

export class MessageDetails {
    public closed: boolean = false;

    constructor(
        public level: MessageLevel,
        public text: string,
        public translationParams: Record<string, string | number> = {},
        public icon?: string,
        public showIcon: boolean = true,
        public link?: string,
        public onActivate?: () => void) {
    }
}
